import { render, staticRenderFns } from "./QuickSurvey.vue?vue&type=template&id=75637ad1&scoped=true&"
import script from "./QuickSurvey.vue?vue&type=script&lang=js&"
export * from "./QuickSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75637ad1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScrollYReverseTransition } from 'vuetify/lib/components/transitions';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VBtn,VIcon,VScrollYReverseTransition,VScrollYTransition})
